import { connect } from 'react-redux'
import NoteslView from '../../../components/Sections/Imi/Notes'
import { loadNotes, loadImis, loadSectors, loadNotesBySector, searchNotesByForm } from '../../../actions/imi';

const mapStateToProps = (state, ownProps) => {
  return {
  	notes: state.imi.notes,
  	imi: state.imi.imiDetail,
  	imisList: state.imi.list,
  	sectors: state.imi.sectors
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 		loadNotes: id => dispatch(loadNotes(id)),
 		loadImis: value => dispatch(loadImis()),
 		loadSectors: () => dispatch(loadSectors()),
 		onSelectSector: (value, idImi) => dispatch(loadNotesBySector(value, idImi)),
 		searchNotesByForm: value => dispatch(searchNotesByForm(value))
  }
}

const Imi = connect(
  mapStateToProps,
  mapDispatchToProps
)(NoteslView)

export default Imi


// WEBPACK FOOTER //
// ./src/containers/Sections/Imi/notes.js